var _rect, _g, _rect2, _g2, _rect3, _g3, _rect4, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "maps",
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.453,
    height: 245.267,
    viewBox: "0 0 77.453 245.267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 25.818,
    height: 3.227,
    rx: 1.614,
    fill: "#bbbbbc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(5.379 16.136)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 57.014,
    height: 3.227,
    rx: 1.614,
    transform: "translate(0 10.757)",
    fill: "#bbbbbc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 57.014,
    height: 3.227,
    rx: 1.614,
    transform: "translate(0 21.515)",
    fill: "#bbbbbc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 57.014,
    height: 3.227,
    rx: 1.614,
    fill: "#bbbbbc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 57.014,
    height: 3.227,
    rx: 1.614,
    transform: "translate(0 32.272)",
    fill: "#bbbbbc"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 25.818,
    height: 3.227,
    rx: 1.614,
    transform: "translate(10.757 64.544)",
    fill: "#bbbbbc"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(20.439 80.68)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77-2",
    "data-name": "Rectangle 77",
    width: 57.014,
    height: 3.227,
    rx: 1.614,
    transform: "translate(0 10.757)",
    fill: "#bbbbbc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78-2",
    "data-name": "Rectangle 78",
    width: 57.014,
    height: 3.227,
    rx: 1.614,
    transform: "translate(0 21.515)",
    fill: "#bbbbbc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75-2",
    "data-name": "Rectangle 75",
    width: 57.014,
    height: 3.227,
    rx: 1.614,
    fill: "#bbbbbc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79-2",
    "data-name": "Rectangle 79",
    width: 57.014,
    height: 3.227,
    rx: 1.614,
    transform: "translate(0 32.272)",
    fill: "#bbbbbc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 57.014,
    height: 3.227,
    rx: 1.614,
    transform: "translate(0 43.029)",
    fill: "#bbbbbc"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 25.818,
    height: 3.227,
    rx: 1.614,
    transform: "translate(10.757 139.845)",
    fill: "#bbbbbc"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(20.439 155.982)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77-3",
    "data-name": "Rectangle 77",
    width: 57.014,
    height: 3.227,
    rx: 1.614,
    transform: "translate(0 10.757)",
    fill: "#bbbbbc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78-3",
    "data-name": "Rectangle 78",
    width: 57.014,
    height: 3.227,
    rx: 1.614,
    transform: "translate(0 21.515)",
    fill: "#bbbbbc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75-3",
    "data-name": "Rectangle 75",
    width: 57.014,
    height: 3.227,
    rx: 1.614,
    fill: "#bbbbbc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79-3",
    "data-name": "Rectangle 79",
    width: 57.014,
    height: 3.227,
    rx: 1.614,
    transform: "translate(0 32.272)",
    fill: "#bbbbbc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81-2",
    "data-name": "Rectangle 81",
    width: 57.014,
    height: 3.227,
    rx: 1.614,
    transform: "translate(0 43.029)",
    fill: "#bbbbbc"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 25.818,
    height: 3.227,
    rx: 1.614,
    transform: "translate(5.379 215.147)",
    fill: "#bbbbbc"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(10.757 231.283)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 57.014,
    height: 3.227,
    rx: 1.614,
    transform: "translate(0)",
    fill: "#bbbbbc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 57.014,
    height: 3.227,
    rx: 1.614,
    transform: "translate(0 10.757)",
    fill: "#bbbbbc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaps);
export default __webpack_public_path__ + "static/media/maps.f8aecb8bda96cf7743de1a5d9619946b.svg";
export { ForwardRef as ReactComponent };